import { render } from "./BaseIcon.vue?vue&type=template&id=7d4424af&scoped=true"
import script from "./BaseIcon.vue?vue&type=script&lang=js"
export * from "./BaseIcon.vue?vue&type=script&lang=js"

import "./BaseIcon.vue?vue&type=style&index=0&id=7d4424af&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7d4424af"

export default script